import { Component, OnInit } from '@angular/core';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { CountryItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { CustomerItem, TypeaheadService } from '../../../services/typeahead.service';

@Component({
  selector: 'tt-business-co',
  templateUrl: './business-co.component.html',
  styleUrls: ['./business-co.component.css']
})
export class BusinessCoComponent implements OnInit {
    businessCoNo;

    public productSettingsButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fa fa-bars', goto: 'productsettings' }];

    public edit?: Edit;

    public selectListCountries: CountryItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public selectListStockPlacesCentral: StockplaceItem[] = [];

    public selectListProductSettings: Item[] = [];

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService, private typeahead: TypeaheadService) {
        this.businessCoNo = this.stateService.getStateParams()['businessco_no'];
    }

    private async loadEdit() {
        if (!!this.businessCoNo) {
            this.edit = (await this.datatask.Post(1509, { businessco_no: this.businessCoNo }))[0];
        }
    }

    private async loadCountries() {
        this.selectListCountries = await this.logistic.getCountries();
    }

    private async loadStockPlacesCentral() {
        this.selectListStockPlacesCentral = await this.logistic.getStockplaces({ businessco_no: '0' });
    }

    private async loadProductSettings() {
        this.selectListProductSettings = await this.datatask.Post(673);
    }

    private async loadStockPlaces() {
        if (!this.edit) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({ businessco_no: this.edit.businessco_no });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1510, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public searchCustomerNames = () => {
        return this.typeahead.searchCustomer({
            cust_name: this.edit!.cust_name,
            custtype: 'S',
            lastselect: 'SEARCH'
        });
    }

    public onCustomerNameSelected(event?: CustomerItem) {
        if (!this.edit) return;

        this.edit.cust_no = !!event ? '' + event.item_id : '0';
        this.edit.cust_name = event?.item_name ?? '';
    }

    private async init() {
        await this.loadEdit();
        this.loadCountries();
        this.loadStockPlacesCentral();
        this.loadProductSettings();
        this.loadStockPlaces();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    businessco_no: string;
    businessco_companyname: string;
    address1: string;
    address2: string;
    postplace_id: string;
    postplace_name: string;
    phone: string;
    fax: string;
    organisation_no: string;
    country_id: string;
    stockplace_id: string;
    purch_std_deladr_custno: string;
    purch_std_deladr_cust_name: string;
    swift_address: string;
    iban: string;
    special1: string;
    special2: string;
    special3: string;
    special4: string;
    bank_name: string;
    isactive: string;
    bank_account: string;
    bankintegration_api_company_id: string;
    bankintegration_external_api_keyno: string;
    mainmenu_logo: string;
    stockplace_id_central: string;
    cust_no: string;
    cust_name: string;
    productsetting_keyno_new_product: string;
    productsetting_keyno_new_product_materialgrade: string;
}
